import useCurrentRoute from '@/composables/useCurrentRoute'

export default async function useRouteNameTrack() {
  const { name: routeName } = await useCurrentRoute()
  return {
    async hasRouteChanged(showWarn: boolean = false) {
      const { name: routeNameAfter } = await useCurrentRoute()

      if (routeName !== routeNameAfter && showWarn) {
        console.warn('useRouteNameTrack', routeName, routeNameAfter)
      }

      return routeName !== routeNameAfter
    },
  }
}
